export default "__VITE_ASSET__NHWsDfrl__"